<template>

  <b-navbar
      class="shadow bg-white rounded-nav d-print-none"
      toggleable="md"
      type="light"
      variant="fade">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav v-for="menu in storeMenus" :key="menu.id" v-if="menu.position==='store_nav'">

        <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>

        <li class="nav-item icons stick-left">
          <router-link class="px-3" :to="{name:'Profile'}">
            <b-icon class="h4 m-0" icon="person-check-fill" variant="secondary"></b-icon>
          </router-link>
          <router-link v-if="isAuth  ||findAttributeOnSiteInfo('cartType') == 1" class="px-3" :to="{name:'ShoppingCart'}">
            <b-icon class="h4 m-0" icon="bag-check-fill" variant="secondary"></b-icon>
          </router-link>
          <router-link v-else class="px-3" :to="{name:'UnAuthenticatedShoppingCart'}">
            <b-icon class="h4 m-0" icon="bag-check-fill" variant="secondary"></b-icon>
          </router-link>

          <m-search-input-1 class="d-inline bg-transparent"/>

        </li>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>


</template>

<script>
import {mapGetters} from "vuex";
import NavMenuItem from "./NavMenuItem";

export default {
  name: "Nav5",
  components: {NavMenuItem},
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus",
      isAuth: "User/isAuthenticated",
    })
  },
  mounted() {

  },
}
</script>

<style scoped>
.stick-left {
  position: absolute;
  left: 20px;
  top: 15px;
}

.rounded-nav {
  border-radius: 42px !important;
  color: black;
}
</style>